import { useLocation } from "react-router-dom";

export function useAttribution(landing) {
  const { search } = useLocation(); const p = new URLSearchParams(search);
  const ref = p.get("ref") || localStorage.getItem("velocity_ref") || "";
  if (p.get("ref")) localStorage.setItem("velocity_ref", p.get("ref"));
  return { utm_source: p.get("utm_source") || "", utm_medium: p.get("utm_medium") || "", utm_campaign: p.get("utm_campaign") || "", utm_content: p.get("utm_content") || "", ref, campaign_id: p.get("campaign_id") || "", landing_page: landing, referrer: document.referrer || "" };
}

export function ConsentControls({ consent, setConsent, testid }) {
  return (
    <div className="space-y-1 text-xs text-slate-400" data-testid={testid}>
      <p className="font-mono text-[10px] uppercase tracking-widest text-slate-500">How may we contact you?</p>
      {[["email", "Email about this inquiry (required to receive a reply)"], ["sms", "Text messages — reply STOP to opt out anytime"], ["calls", "Phone calls during business hours"]].map(([k, l]) => <label key={k} className="flex items-center gap-2"><input type="checkbox" checked={!!consent[k]} onChange={(e) => setConsent({ ...consent, [k]: e.target.checked })} data-testid={`${testid}-${k}`} />{l}</label>)}
    </div>
  );
}

export function LeadSuccess({ kind, res, testid }) {
  return (
    <div className="p-6 rounded-2xl border border-emerald-400/30 bg-emerald-400/5 space-y-2" data-testid={testid}>
      <p className="font-display text-xl font-bold">Inquiry saved — we'll reach out within {res.sla_hours} hours.</p>
      <p className="text-sm text-slate-300">Reference <span className="font-mono text-cyan-300">{res.lead_id}</span>.{res.callback ? " A callback is queued for the window you chose." : ""}</p>
      <p className="text-xs text-amber-300/90">Submitting an inquiry does not confirm a {kind === "driver" ? "reservation" : "listing"}. Nothing has been charged. A team member will confirm availability and next steps with you.</p>
    </div>
  );
}
